<template>
    <div>
        <validation-provider
            mode="eager"
            v-slot="{ valid, errors }"
            :vid="name"
            :rules="validationRules"
        >
            <div class="input form-floating">
                <input
                    type="tel"
                    inputmode="tel"
                    :autocomplete="autocomplete"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    v-mask="'###-###-####'"
                    :id="name"
                    :name="name"
                    :placeholder="dynamicPlaceholder"
                    :data-testid="dataTestid"
                    v-model="phoneValue"
                    @blur="onBlur($event.target)"
                    @focus="onFieldFocus($event.target)"
                >
                <label
                    v-if="label"
                    :for="name"
                >{{ label }}</label>
                <div class="invalid-feedback">
                    {{ errors[0] }}
                </div>
            </div>
        </validation-provider>
    </div>
</template>

<script>
    import { formInputMixin } from 'aven_shared/src/mixins/formInputMixin'
    import { log } from '@/utils/logger'

    export default {
        name: 'FormFieldPhone',
        mixins: [formInputMixin],
        props: {
            validationRules: { type: String, default: 'required|phoneNumberRule' },
            dataTestid: {
                type: String,
                required: false,
            },
            autocomplete: {
                type: String,
                default: 'tel',
            },
            defaultValue: {
                type: String,
                default: '',
            },
            focusEvent: {
                type: String,
                required: false,
            },
        },
        methods: {
            onFieldFocus(target) {
                if (this.focusEvent) {
                    this.$logEvent(this.focusEvent)
                }

                this.$emit('focus', target)
            },
        },
        data() {
            return {
                phoneValue: this.defaultValue,
            }
        },
        watch: {
            phoneValue: function (newValue, oldValue) {
                log.info('phoneValue: %{oldValue} -> %{newValue}', { oldValue, newValue })
                const filteredValue = newValue?.replace(/[()-.]/gi, '')
                this.$emit('input', filteredValue)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/onboardingV2.scss';

    /* Dark mode styles using ".dark &" pattern (ancestor selector) */
    .dark .form-control {
        @extend .dark-mode-input;
    }

    .dark label {
        @extend .dark-mode-label;
    }
</style>
